import { useMutation, useQueryClient } from "react-query";
import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChangeControlElement } from "../../types/router";
import { designControlsApi } from "../../api/designControls";

export const useSendForApproval = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { changeControlId: reviewId } =
    useParams<ChangeControlElement>() as ChangeControlElement;
  const queryClient = useQueryClient();
  const { showToast } = useToastProvider();

  return useMutation({
    mutationFn: () =>
      designControlsApi.sendForApproval(companyId, productId, reviewId),
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        "REVIEW",
        companyId,
        productId,
        reviewId,
      ]);
      showToast({
        title: t("reviews.notifications.sendForApprovalSuccess.title"),
        description: t(
          "reviews.notifications.sendForApprovalSuccess.description",
        ),
        status: "success",
        "data-cy": "toast-review-send-for-approval-success",
      });
    },
    onError: () => {
      showToast({
        title: t("reviews.notifications.sendForApprovalError.title"),
        description: t(
          "reviews.notifications.sendForApprovalError.description",
        ),
        status: "error",
        "data-cy": "toast-review-send-for-approval-error",
      });
    },
  });
};
